var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIncludeZipImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6673 8.00033V6.16699H15.5007V8.00033H13.6673ZM13.6673 9.83366H11.834V8.00033H13.6673V9.83366ZM13.6673 11.667V9.83366H15.5007V11.667H13.6673ZM9.2444 4.33366L7.41107 2.50033H2.66732V13.5003H11.834V11.667H13.6673V13.5003H17.334V4.33366H13.6673V6.16699H11.834V4.33366H9.2444ZM2.66732 15.3337C2.16315 15.3337 1.73155 15.1541 1.37253 14.7951C1.0135 14.4361 0.833984 14.0045 0.833984 13.5003V2.50033C0.833984 1.99616 1.0135 1.56456 1.37253 1.20553C1.73155 0.846506 2.16315 0.666992 2.66732 0.666992H8.16732L10.0007 2.50033H17.334C17.8382 2.50033 18.2697 2.67984 18.6288 3.03887C18.9878 3.39789 19.1673 3.82949 19.1673 4.33366V13.5003C19.1673 14.0045 18.9878 14.4361 18.6288 14.7951C18.2697 15.1541 17.8382 15.3337 17.334 15.3337H2.66732Z",
    fill: "#5E6974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIncludeZipImages);
export default __webpack_public_path__ + "static/media/export-include-zip-images.3ba538d2da754b8b2600771cbcd43c75.svg";
export { ForwardRef as ReactComponent };